import { on } from 'delegated-events'

const siteHeader = document.querySelector('.site-header')
const siteSearch = document.querySelector('.site-search')

const toggleSearch = () => {
  if (document.documentElement.classList.contains('js-site-search-open')) {
    document.documentElement.classList.remove('js-site-search-open')

    siteSearch.reset()
  } else {
    document.documentElement.classList.add('js-site-search-open')

    siteSearch.querySelector('input').focus()
  }
}

export default {
  can: () => document.contains(siteHeader),
  run: () => {
    on('click', '.site-search-trigger', toggleSearch)
  },
}
